import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import * as requestToApi from "./PromotionCRUD";
import { promotionSlice } from "./PromotionSlice";

const { actions } = promotionSlice;

export const fetchPromotionList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .getPromotionList(queryParams)
    .then((response) => {
      if (response && response.data) {
        if (!response.data.isAbort) {
          dispatch(actions.promotionListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: getPromotionList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};
